import React, { useEffect, useState } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import './Menu.css';

const Home = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [currentPath, setCurrentPath] = useState(location.pathname);

  const handleMenuClick = (event, targetPath) => {
    if (location.pathname.startsWith(targetPath)) {
      window.location.href = targetPath; // Полная перезагрузка страницы
      event.preventDefault();
    }
  };

  const isActive = (path) => {
    if (path === '/') return currentPath === '/';
    return currentPath.startsWith(path);
  };

  useEffect(() => {
    setCurrentPath(location.pathname);
  }, [location]);

  return (
    <div className='body'>
      <div id='menubackimage' />
      <div className="menubox">
        <div className="menulinks">
          {/* Используем isActive для динамических классов */}
          <div className={`menulinkschapter ${isActive('/') ? 'now' : ''}`} id="main">
            <Link to='/' className="menulinkschaptertext">ГЛАВНАЯ</Link>
          </div>
          
          <div className={`menulinkschapter ${isActive('/shop') ? 'now' : ''}`} id="shop">
            <Link to='/shop' className="menulinkschaptertext">МАГАЗИН</Link>
          </div>

          <div className={`menulinkschapter ${isActive('/music') ? 'now' : ''}`} id="music">
            <Link to='/music' className="menulinkschaptertext">МУЗЫКА</Link>
          </div>

          <div className={`menulinkschapter ${isActive('/tickets') ? 'now' : ''}`} id="tickets">
            <Link to='/tickets' className="menulinkschaptertext">БИЛЕТЫ</Link>
          </div>

          <div className={`menulinkschapter ${isActive('/contacts') ? 'now' : ''}`} id="contacts">
            <Link to='/contacts' className="menulinkschaptertext">КОНТАКТЫ</Link>
          </div>
        </div>
      </div>
      <div className='menulright'>
        <Link to='/' className='menulrighttext'>л.</Link>
      </div>
    </div>
  );
};

export default Home;